module.exports = LandingCtrl;

// @ngInject
function LandingCtrl($state, $stateParams, $timeout, $anchorScroll, SiteVisitApi, Alert, localStorageService, validCheck, moment) {
	try {
    var vm = this;
		vm.moduleName = 'LandingCtrl'
		
		console.log(vm.moduleName, localStorageService.get('state'))

		console.log(validCheck);
    if(!validCheck) {
			// No valid case id
			Alert.addAlert({ title: 'Error', message: 'Invalid Norkring case id: ' + $stateParams.id, type: 'errorAlert', alertClass: 'alert-danger'});
			$timeout(function() {
				return $state.go('unknown')
			}, 3000);
		} else if (validCheck.status === 'SERVER_ERROR') {
			Alert.addAlert({ title: 'Error', message: 'Unable to connect to SiteVisit server', type: 'errorAlert', alertClass: 'alert-danger'});
		};

		vm.case = {	id: parseInt($stateParams.id), type: $stateParams.type.toUpperCase() };
		vm.visitor = JSON.parse(localStorageService.get('visitor'));

		// Make sure default country code (47) is set
		if (!vm.visitor) vm.visitor = {};
		if (typeof vm.visitor.countryCode === "undefined") vm.visitor.countryCode=47;

		vm.authInit = function () {
			try {
				vm.busyMsg = "Request visit code";
				vm.isBusy = true;
				localStorageService.set('visitor', JSON.stringify(vm.visitor));
				localStorageService.set('position', JSON.stringify(vm.position));
				localStorageService.set('lastTime', vm.lastTime);
				SiteVisitApi.authInit(vm.visitor, vm.case, vm.position, {}).then(
					function(data) {
						try {
							vm.isBusy = false;
							switch (data.status) {
								case 'OK':
									localStorageService.set('state', data.visitStatus);
									localStorageService.set('visitId', data.visitId);								
									localStorageService.set('visitType', data.visitType);
									localStorageService.set('case', JSON.stringify(vm.case));

                  /*
                    If data.visitType = 'UPDATE' - this is a re-visit.
                    A re-visit has 2 cases identified by data.visitStatus value:
                      1:  'VERIFY' - not on-site yet
                      2:  'ONSITE' - is on-site and data.onsiteDate contain the on-site date as Unix epoch.check-in already on-site with valid onSiteDateTime (and offSiteDateTime) in localStore
                          Save this date in localStore as "onSiteDateTime"
                  */
									if ((data.visitStatus === 'ONSITE' ||  data.visitStatus === 'CALL_NOC') && data.visitType === 'UPDATE') {
										// Save date.onsiteDate to localStore
										localStorageService.set('onSiteDateTime', moment(parseInt(data.onsiteDate) * 1000).format());
									}
									$state.go('auth')
									break;
								case 'UNKNOWN':
									console.log('authInit:', data.status, data.message);
									vm.unknownUser = true;
									Alert.addAlert({ title: 'Notice', message: 'Unknown user and company for phone number: ' + vm.visitor.countryCode + ' ' + vm.visitor.phoneNumber, type: 'infoAlert', alertClass: 'alert-info'});
									$anchorScroll();
									break;
								default:
									console.log('authInit:', data.status, data.message);
									Alert.addAlert({ title: 'Error', message: 'Unexpected error: ' + data.message, type: 'errorAlert', alertClass: 'alert-danger'});
									$anchorScroll();
							}
						} catch(error) {
							vm.isBusy = false;
							Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
							$anchorScroll();
						}
					},
					function(error) {
						vm.isBusy = false;
						Alert.addAlert({ title: 'Error', message: error, type: 'errorAlert', alertClass: 'alert-danger'});
						$anchorScroll();
					}
				)
			} catch(error) {
				vm.isBusy = false;
				Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
				$anchorScroll();
			}
		}
	} catch(error) {
		vm.isBusy = false;
		Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName} );
		$anchorScroll();
	}
}
